// extracted by mini-css-extract-plugin
export var quillEditor = "_nz-1";
export var variable = "_nz-0";